import React, { useRef } from "react";
import "../styles/MembershipFeaturesTable.css";
import { useTranslation } from "react-i18next";
import { useScroll } from "../context/ScrollContext";
import { FaCheck } from "react-icons/fa";

const rows = [
  { label: "Create a profile", free: true, standard: true, premium: true },
  { label: "Messaging", free: true, standard: true, premium: true },
  { label: "Basic Filters", free: true, standard: true, premium: true },
  { label: "Advanced Filters", free: false, standard: true, premium: true },
  { label: "Unlimited likes", free: false, standard: true, premium: true },
  {
    label: "Message users who liked you",
    free: false,
    standard: true,
    premium: true,
  },
  { label: "View mutual likes", free: false, standard: true, premium: true },
  {
    label: "See others' dynamic cards",
    free: false,
    standard: true,
    premium: true,
  },
  {
    label: "Start games with other users",
    free: false,
    standard: true,
    premium: true,
  },
  {
    label: "Matching algorithm",
    free: false,
    standard: false,
    premium: true,
    highlight: true,
  },
];

const MembershipFeaturesTable = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const { sectionRefs } = useScroll();
  sectionRefs.features = sectionRef;

  const renderCell = (value, premium = false) => {
    let content;
    if (value === "soon") {
      content = <span className="feature-soon">{t(`Coming soon`)}</span>;
    } else if (value) {
      content = <FaCheck className="feature-check" />;
    } else {
      content = <span className="feature-dash">—</span>;
    }
    return <td className={premium ? "col-premium" : ""}>{content}</td>;
  };

  return (
    <div
      ref={sectionRef}
      id="features-section"
      className="membership-features-container"
    >
      <table className="membership-features-table">
        <thead>
          <tr>
            <th className="col-feature">{t(`Feature`)}</th>
            <th>{t(`Free`)}</th>
            <th>{t(`Standard`)}</th>
            <th className="col-premium th-premium">{t(`Premium`)}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row.label}
              className={row.highlight ? "row-highlight" : ""}
            >
              <td className="col-feature">{t(row.label)}</td>
              {renderCell(row.free)}
              {renderCell(row.standard)}
              {renderCell(row.premium, true)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MembershipFeaturesTable;
